/* eslint-disable import/prefer-default-export */

// ISO 4217
export enum CURRENCY_CODE {
    EUR = 'EUR',
    GBP = 'GBP',
    PLN = 'PLN',
    ZAR = 'ZAR',
}
